import { n, s as safeDefineFsComponent } from './query-assigned-elements.js';
import { i, s, x, b } from './lit-element.js';
import { e as e$1 } from './directive.js';
import { e } from './unsafe-html.js';

var styles = i`.fs-icon{height:var(--fs-size-medium2,24px);width:var(--fs-size-medium2,24px)}.fs-icon.fs-icon--small{height:var(--fs-size-medium1,16px);width:var(--fs-size-medium1,16px)}.fs-icon.fs-icon--neutral{color:currentColor;fill:currentColor}.fs-icon.fs-icon--disabled.fs-icon--disabled{cursor:not-allowed;fill:var(--fs-icon-color-disabled,hsl(0,0%,49%))}.fs-icon.fs-icon--primary{fill:var(--fs-icon-color-primary,hsl(0,0%,8%))}.fs-icon.fs-icon--secondary{fill:var(--fs-icon-color-secondary,hsl(0,0%,41%))}.fs-icon.fs-icon--inverse{fill:var(--fs-icon-color-inverse,hsl(0,0%,100%))}.fs-icon.fs-icon--feedback-info{fill:var(--fs-icon-color-feedback-info,hsl(200,98%,35%))}.fs-icon.fs-icon--feedback-positive{fill:var(--fs-icon-color-feedback-positive,hsl(108,80%,28%))}.fs-icon.fs-icon--feedback-warning{fill:var(--fs-icon-color-feedback-warning,hsl(47,95%,50%))}.fs-icon.fs-icon--feedback-critical{fill:var(--fs-icon-color-feedback-critical,hsl(359,70%,47%))}.fs-icon.fs-icon--interactive.fs-icon--primary{cursor:pointer;fill:var(--fs-icon-color-interactive-primary-default,hsl(200,98%,35%))}.fs-icon.fs-icon--interactive.fs-icon--primary:hover{fill:var(--fs-icon-color-interactive-primary-hover,hsl(200,97%,30%))}.fs-icon.fs-icon--interactive.fs-icon--primary:focus{fill:var(--fs-icon-color-interactive-primary-focus,hsl(200,97%,30%))}.fs-icon.fs-icon--interactive.fs-icon--primary:active{fill:var(--fs-icon-color-interactive-primary-active,hsl(200,98%,23%))}.fs-icon.fs-icon--interactive.fs-icon--secondary{cursor:pointer;fill:var(--fs-icon-color-interactive-secondary-default,hsl(0,0%,41%))}.fs-icon.fs-icon--interactive.fs-icon--secondary:hover{fill:var(--fs-icon-color-interactive-secondary-hover,hsl(0,0%,32%))}.fs-icon.fs-icon--interactive.fs-icon--secondary:focus{fill:var(--fs-icon-color-interactive-secondary-focus,hsl(0,0%,32%))}.fs-icon.fs-icon--interactive.fs-icon--secondary:active{fill:var(--fs-icon-color-interactive-secondary-active,hsl(0,0%,24%))}.fs-icon.fs-icon--interactive.fs-icon--destructive{cursor:pointer;fill:var(--fs-icon-color-interactive-destructive-default,hsl(359,70%,47%))}.fs-icon.fs-icon--interactive.fs-icon--destructive:hover{fill:var(--fs-icon-color-interactive-destructive-hover,hsl(359,66%,44%))}.fs-icon.fs-icon--interactive.fs-icon--destructive:focus{fill:var(--fs-icon-color-interactive-destructive-focus,hsl(359,66%,44%))}.fs-icon.fs-icon--interactive.fs-icon--destructive:active{fill:var(--fs-icon-color-interactive-destructive-active,hsl(359,61%,40%))}.fs-icon.fs-icon--interactive.fs-icon--inverse{cursor:pointer;fill:var(--fs-icon-color-interactive-inverse-default,hsl(0,0%,100%))}.fs-icon.fs-icon--interactive.fs-icon--inverse:hover{fill:var(--fs-icon-color-interactive-inverse-hover,hsl(0,0%,96%))}.fs-icon.fs-icon--interactive.fs-icon--inverse:focus{fill:var(--fs-icon-color-interactive-inverse-focus,hsl(0,0%,96%))}.fs-icon.fs-icon--interactive.fs-icon--inverse:active{fill:var(--fs-icon-color-interactive-inverse-active,hsl(0,0%,90%))}.fs-icon-button{align-items:center;background:transparent;border:0;border-radius:var(--fs-radius-tiny,2px);box-sizing:border-box;cursor:pointer;display:inline-flex;justify-content:center;height:var(--fs-size-large1,32px);padding:0;width:var(--fs-size-large1,32px)}.fs-icon-button.fs-icon__button--compact{height:calc(var(--fs-size-medium1, 16px) + 2px);width:calc(var(--fs-size-medium1, 16px) + 2px)}.fs-icon-button:focus{outline:0;outline:0;box-shadow:0 0 0 2px var(--fs-color-focus-secondary-default,hsl(0,0%,100%)),0 0 0 4px var(--fs-color-focus-primary-default,hsl(200,98%,35%))}`;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class t extends e{}t.directiveName="unsafeSVG",t.resultType=2;const o=e$1(t);

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const iconMap = new Map();
/**
 * The web component implementation of the Financial Services icon component. This package, together with data from `@cof/fs-icons` will enable developers to import Gravity-approved, optimized icons into their application and use them within the confines of the design system.
 *
 * ## Installation
 *
 * ```bash
 * npm i @cof/fs-icons @cof/fs-icon-wc
 * ```
 *
 * ## Usage
 *
 * To import the side-effectful registration of `<fs-icon>`, call
 *
 * ```javascript
 * import { FsIcon} from '@cof/fs-icon-wc/fs-icon.js';
 * ```
 *
 * To import the `FsIcon` class alone either to use as a base class or self-register the component or to gain access to the `add` static method, use
 *
 * ```javascript
 * import { FsIcon} from '@cof/fs-icon-wc';
 * ```
 *
 * To import icons to be used in the component, you'll need to grab those icons from the `@cof/fs-icons` package. The names and exports for those icons should match the data in the Figma file you are referencing. For example, if you are looking to use the icon `fs-16-checkmark`, you would do the following:
 *
 * ```javascript
 * import { FsIcon } from '@cof/fs-icon-wc/fs-icon.js';
 * import { fs16Checkmark } from '@cof/fs-icons';
 *
 * FsIcon.add(fs16Checkmark); // this can take either single icons or an array of icons
 * ```
 *
 * You can then use the corresponding icon in your HTML:
 *
 * ```html
 * <fs-icon icon="fs-16-checkmark" description="Checkmark icon"></fs-icon>
 * ```
 *
 * Note, the imports from `@cof/fs-icons` will be pascalCase where as the icon names for the element will be kebab-case.
 *
 * @element fs-icon
 */
class FsIcon$1 extends s {
    constructor() {
        super(...arguments);
        /** Placeholder for interactive */
        this._interactive = false;
        /** The icon's description, should reflect the usage and content of the icon */
        this.description = '';
        /** If set to true, the icon will become disabled */
        this.disabled = false;
        /** The icon name to use, this key must be added to the icon's constructor via the static add method */
        this.icon = '';
        /**
         * The icon's variant. Possible values are 'primary', 'secondary', 'inverse',
         * 'feedback-info', 'feedback-warning', 'feedback-positive' and 'feedback-critical'.
         * The variant, and the icon's interactive state, determine the item's fill within the
         * confines of the design system.
         */
        this.variant = 'neutral';
    }
    static get styles() {
        return [
            styles,
            i `
        :host { box-sizing: border-box; color: inherit; display: inline-block; line-height: 0; }
        :host(:focus) {
          box-shadow: none;
          outline: 0;
        }
      `
        ];
    }
    /**
     * This method takes a tuple of [iconName, iconData] from the @cof/fs-icons package.
     * You can pass in either a single icon definition or a list of icon definitions that will
     * become renderable once registered.
     *
     * @example
     * ```javascript
     * import { FsIcon } from '@cof/fs-icon-wc/fs-icon';
     * import { fs24Placeholder } from '@cof/fs-icons';
     *
     * FsIcon.add(fs24Placeholder);
     * ```
     */
    static add(iconDefinition) {
        if (!Array.isArray(iconDefinition) || !iconDefinition.length) {
            throw new Error('You must pass a valid icon defintion to FsIcon.add');
        }
        if (Array.isArray(iconDefinition[0])) {
            iconDefinition.forEach((definition) => {
                iconMap.set(definition[0], definition[1]);
            });
        }
        else {
            const definition = iconDefinition;
            iconMap.set(definition[0], definition[1]);
        }
    }
    /** This item takes an icon name and returns whether the component has that icon registered */
    static has(key) {
        return iconMap.has(key);
    }
    /** This method will return a list of registered icon names */
    static get list() {
        return Array.from(iconMap.keys());
    }
    /** When set to true the icon can serve as a button with primary, secondary and inverse variants */
    get interactive() {
        return this._interactive;
    }
    set interactive(interactive) {
        this._interactive = interactive;
        const event = new CustomEvent('interactive-toggle', { detail: interactive, bubbles: true });
        this.dispatchEvent(event);
        this.requestUpdate();
    }
    /** Manages the icon's role attribute based on accessibility rules */
    get role() {
        if (!this.description) {
            return 'presentation';
        }
        else {
            return this.interactive ? 'button' : 'img';
        }
    }
    /** If the icon used is one of the 16-pixel versions this will be small */
    get size() {
        const size = this.icon && this.icon.includes('16') ? 'small' : 'normal';
        /** Only toggle the attribute on the browser */
        this.toggleAttribute?.('compact', size === 'small');
        return size;
    }
    firstUpdated() {
        const event = new CustomEvent('interactive-toggle', { detail: this.interactive, bubbles: true });
        this.dispatchEvent(event);
    }
    render() {
        if (this.role === 'button') {
            return x `<button class="fs-icon-button ${this.size === 'small' ? 'fs-icon__button--compact' : ''}" ?disabled="${this.disabled}">
        <svg viewBox="${this.size === 'small' ? '0 0 16 16' : '0 0 24 24'}" class="fs-icon fs-icon--interactive ${this.disabled ? 'fs-icon--disabled' : ''} ${this.size === 'small' ? 'fs-icon--small' : ''} fs-icon--${this.variant}" xmlns="http://www.w3.org/2000/svg" part="fs-icon" aria-label="${this.description}">
          ${this.icon ? o(iconMap.get(this.icon)) : ''}
        </svg>
      </button>`;
        }
        return b `<svg viewBox="${this.size === 'small' ? '0 0 16 16' : '0 0 24 24'}" class="fs-icon ${this.interactive ? 'fs-icon--interactive' : ''} ${this.disabled ? 'fs-icon--disabled' : ''} ${this.size === 'small' ? 'fs-icon--small' : ''} fs-icon--${this.variant}" xmlns="http://www.w3.org/2000/svg" part="fs-icon" aria-label="${this.description}" role="${this.role}" aria-disabled="${this.disabled}">
      ${this.icon ? o(iconMap.get(this.icon)) : ''}
    </svg>`;
    }
}
/** The element's canonical name for use with safe define */
FsIcon$1.canonicalName = 'icon';
/**
 * Override the default shadow root options to enable ShadowRoot.prototype.delegatesFocus
 */
FsIcon$1.shadowRootOptions = {
    ...s.shadowRootOptions,
    delegatesFocus: true
};
__decorate([
    n({ type: String })
], FsIcon$1.prototype, "description", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], FsIcon$1.prototype, "disabled", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], FsIcon$1.prototype, "interactive", null);
__decorate([
    n({ type: String, reflect: true })
], FsIcon$1.prototype, "icon", void 0);
__decorate([
    n({ type: String, reflect: true })
], FsIcon$1.prototype, "variant", void 0);

const { customElementClass, safeTagName } = safeDefineFsComponent.define(FsIcon$1);
const FsIcon = customElementClass;

const fs24ChevronLeft = ['fs-24-chevron-left', `<path fill-rule="evenodd" clip-rule="evenodd" d="M15.707 5.707a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L9.414 12l6.293-6.293Z" />`];
const fs24SignOut = ['fs-24-sign-out', `<path fill-rule="evenodd" clip-rule="evenodd" d="M13 6.5a.5.5 0 0 1-.992.09L12 6.5v-1a.5.5 0 0 0-.41-.492L11.5 5h-7a.5.5 0 0 0-.492.41L4 5.5v13a.5.5 0 0 0 .41.492L4.5 19h7a.5.5 0 0 0 .492-.41L12 18.5v-1a.5.5 0 0 1 .992-.09l.008.09v1a1.5 1.5 0 0 1-1.355 1.493L11.5 20h-7a1.5 1.5 0 0 1-1.493-1.355L3 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L4.5 4h7a1.5 1.5 0 0 1 1.493 1.356L13 5.5v1Zm6.29 5H9.5a.5.5 0 1 0 0 1h9.795l-3.149 3.147a.497.497 0 0 0 0 .707.5.5 0 0 0 .707 0l4-3.996a.5.5 0 0 0-.013-.72l-3.987-3.991a.5.5 0 0 0-.707.707L19.29 11.5Z" />`];

export { FsIcon as F, fs24SignOut as a, fs24ChevronLeft as f };
